module.exports = ":root{--lui-typeahead-max-menuitems:5;--lui-typeahead-menuitem-height:var(--lui-control-height);--lui-typeahead-menu-width:none;--lui-typeahead-menu-max-width:none;--lui-typeahead-menu-min-width:100%;--lui-typeahead-width:100%;--lui-typeahead-min-width:none;--lui-typeahead-max-width:none}lui-typeahead input{border:0;clip:rect(0,0,0,0);height:1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-typeahead/theme/lui-typeahead.global.scss
// module id = 366
// module chunks = 0 1 20